import {
  BrandedConfig,
  ENV_BRAND_NWB,
  ENV_BRAND_RBS,
  ENV_BRAND_UBN,
} from "services/envService";

export const SITE_DOWN_HEADER = "Sorry, this page is down.";
export const SITE_DOWN_MESSAGE_1 =
  "Please try again later. Alternatively, get in touch with our Business Team for assistance. Call us on:";
export const SITE_DOWN_MESSAGE_2 = "Please note calls may be recorded.";
export const NUMBERS: BrandedConfig = {
  [ENV_BRAND_NWB]: "0345 711 4477",
  [ENV_BRAND_RBS]: "0345 600 2230",
  [ENV_BRAND_UBN]: "0345 366 5592",
};
export const YOUR_BOUNCE_BACK_LOAN = "Your Bounce Back Loan";
